function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { forwardRef, useTestId } from '../../../../utils';
import { useMultiStyleConfig } from '../../../../utils/use-style-config';
import { NakedButton } from '../../../action';
import { Box } from '../../Box';
import { jsx as _jsx } from "react/jsx-runtime";
export var EmptyState = forwardRef((_ref, ref) => {
  var {
    emptyState,
    closeMenu,
    'data-testid': dataTestId = 'base-select'
  } = _ref;
  var isClickable = Boolean(emptyState.onClick);
  var styles = useMultiStyleConfig('BaseSelect', {
    clickableEmptyState: isClickable
  });

  var handleClick = () => {
    var _emptyState$onClick;

    (_emptyState$onClick = emptyState.onClick) === null || _emptyState$onClick === void 0 ? void 0 : _emptyState$onClick.call(emptyState);
    closeMenu === null || closeMenu === void 0 ? void 0 : closeMenu();
  };

  var sharedProps = {
    'data-component': 'BaseSelect.EmptyState',
    __css: styles['emptyState'],
    ref
  };
  var getTestId = useTestId(dataTestId);
  return isClickable ? /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread(_objectSpread({}, sharedProps), {}, {
    onClick: handleClick
  }, getTestId('clickable-empty-state')), {}, {
    children: /*#__PURE__*/_jsx(NakedButton, {
      variant: "secondary",
      label: emptyState.label
    })
  })) : /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread(_objectSpread({}, sharedProps), {}, {
    "data-disabled": true
  }, getTestId('empty-state')), {}, {
    children: emptyState.label
  }));
});
EmptyState.displayName = 'BaseSelect.EmptyState';
//# sourceMappingURL=EmptyState.js.map